import { ReactNode, useEffect, useRef, useState } from 'react';
import { ArrowUpS } from '@styled-icons/remix-line';

import * as S from './styles';

export type ContractBoxType = {
  children: ReactNode;
  isContractLoaded?: boolean;
};

const ContractBox = ({ children, isContractLoaded }: ContractBoxType) => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const iframeElement = scrollRef.current?.children[0] as HTMLIFrameElement;

  useEffect(() => {
    const onScroll = (e: Event) => {
      const { scrollY = 0 } = e.currentTarget as { scrollY?: number };

      if (scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };

    if (iframeElement?.contentWindow && isContractLoaded) {
      iframeElement.contentWindow.onscroll = onScroll;
    }
  }, [iframeElement, isContractLoaded]);

  const goToTop = () => {
    iframeElement?.contentWindow?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <S.Wrapper>
      <S.Content ref={scrollRef}>{children}</S.Content>
      {showTopBtn && (
        <S.ScrollTop onClick={goToTop}>
          <ArrowUpS size={20} />
        </S.ScrollTop>
      )}
    </S.Wrapper>
  );
};

export default ContractBox;
